module.exports = __webpack_public_path__ + "media/images/emoticons/boutique-67fe28595e3a699cd964cb536b566fff.gif";